import React from 'react';
import { Dashboard } from '../../components/navigation/Dashboard';
import { MySurveys } from '../../components/navigation/MySurveys';
import { TeamMenu } from '../../components/navigation/TeamMenu';

import { UserMenu } from '../../components/user-menu';
import { Variant } from '../types';

const variant: Variant = {
  getMenuItems: (): JSX.Element[] => {
    return [
      <Dashboard key="menu-dashboard" />,
      <MySurveys key="menu-surveys" />,
      <TeamMenu key="menu-team" />,
    ];
  },
  actions: [],
  info: [],
  user: [<UserMenu key="menu-user" />],
  homePage: '/',
};

export default variant;
